export default __webpack_public_path__ + "src/assets/icn-ledger-nano-large.232502432b30c5f3f98489683754fcd5.svg";